/**
 * Emoji the reaction picker offers: 327 of Unicode's 3,800 or so, chosen for work chat,
 * each with a Korean name (what a screen reader says) and Korean and English search
 * words. Bundled with the app (no font or image download; 15 KB minified, 8 KB gzip);
 * the server takes any single RGI emoji, so a later picker can offer more without a
 * server change.
 *
 * One line per emoji: `<emoji> <name>|<search words>`.
 */
const GROUPS = {
  faces: `😀 활짝 웃는 얼굴|웃음 기쁨 행복 smile grin happy
😃 눈 크게 뜨고 웃는 얼굴|웃음 기쁨 smiley
😄 눈웃음 짓는 얼굴|웃음 기쁨 하하 smile
😁 이를 드러내고 웃는 얼굴|웃음 히히 grin
😆 눈 감고 크게 웃는 얼굴|웃음 빵터짐 ㅋㅋ laughing
😅 식은땀 흘리며 웃는 얼굴|민망 머쓱 땀 sweat smile
🤣 데굴데굴 구르며 웃는 얼굴|웃음 ㅋㅋㅋ 빵터짐 rofl
😂 기뻐서 우는 얼굴|웃음 눈물 ㅋㅋㅋ 웃겨 joy lol
🙂 살짝 웃는 얼굴|미소 좋아 slightly smiling
🙃 거꾸로 된 얼굴|장난 upside down
😉 윙크하는 얼굴|윙크 장난 wink
😊 수줍게 웃는 얼굴|미소 행복 감사 blush
😇 천사 얼굴|천사 착함 angel innocent
🥰 하트에 둘러싸인 얼굴|사랑 좋아 smiling hearts love
😍 하트 눈 얼굴|사랑 반함 좋아 heart eyes
🤩 별 눈 얼굴|감동 신남 대박 star struck
😘 뽀뽀하는 얼굴|뽀뽀 사랑 kiss
😋 맛있게 먹는 얼굴|맛있다 냠냠 yum
😛 혀를 내민 얼굴|메롱 장난 tongue
😜 윙크하며 혀를 내민 얼굴|메롱 장난 wink tongue
🤪 익살맞은 얼굴|장난 신남 zany crazy
🤗 안아 주는 얼굴|포옹 허그 감사 hug
🤭 손으로 입 가린 얼굴|키득 웃음참기 giggle
🫢 눈 뜨고 입 가린 얼굴|놀람 헉 gasp
🤫 쉿 하는 얼굴|조용 비밀 shush quiet
🤔 생각하는 얼굴|고민 글쎄 흠 thinking
🫡 경례하는 얼굴|경례 넵 알겠습니다 확인 salute
🤐 입에 지퍼를 채운 얼굴|비밀 zipper mouth
🤨 눈썹을 치켜든 얼굴|의심 갸우뚱 raised eyebrow
😐 무표정한 얼굴|무표정 그냥 neutral
😑 표정 없는 얼굴|무덤덤 expressionless
😶 입 없는 얼굴|할말없음 no mouth
🫠 녹아내리는 얼굴|녹음 더워 민망 melting
😏 능글맞게 웃는 얼굴|능글 smirk
😒 시큰둥한 얼굴|불만 unamused
🙄 눈 굴리는 얼굴|어이없음 eye roll
😬 이를 드러낸 어색한 얼굴|어색 긴장 grimace
😮‍💨 한숨 쉬는 얼굴|한숨 휴 exhale
😌 안도하는 얼굴|안심 휴 relieved
😔 생각에 잠긴 얼굴|우울 아쉬움 pensive
😪 졸린 얼굴|졸림 sleepy
😴 잠든 얼굴|잠 졸림 zzz sleeping
😷 마스크 쓴 얼굴|감기 아픔 마스크 mask sick
🤒 체온계를 문 얼굴|아픔 열 thermometer sick
🤕 머리에 붕대를 감은 얼굴|다침 아픔 bandage hurt
🥵 더운 얼굴|더워 뜨거움 hot
🥶 추운 얼굴|추워 cold
🥴 어지러운 얼굴|어지러움 woozy
😵‍💫 눈이 빙글빙글 도는 얼굴|어지러움 혼란 dizzy
🤯 머리가 폭발한 얼굴|충격 대박 mind blown
🥳 파티하는 얼굴|축하 파티 생일 party
😎 선글라스 쓴 얼굴|멋짐 쿨 cool sunglasses
🤓 안경 쓴 얼굴|공부 nerd
🧐 외알 안경 쓴 얼굴|관찰 검토 monocle
😕 혼란스러운 얼굴|당황 confused
😟 걱정하는 얼굴|걱정 worried
🙁 살짝 찡그린 얼굴|아쉬움 slightly frowning
😮 입을 벌린 얼굴|놀람 오 wow surprised
😯 조용히 놀란 얼굴|놀람 hushed
😲 깜짝 놀란 얼굴|놀람 헉 astonished
😳 얼굴이 빨개진 얼굴|당황 부끄러움 flushed
🥺 애원하는 얼굴|부탁 제발 글썽 pleading
🥹 눈물을 참는 얼굴|감동 뭉클 holding back tears
😨 겁먹은 얼굴|무서움 fearful
😰 식은땀 흘리는 얼굴|불안 걱정 anxious
😥 실망했지만 안도한 얼굴|휴 아쉬움 sad relieved
😢 우는 얼굴|슬픔 눈물 cry sad
😭 엉엉 우는 얼굴|슬픔 눈물 감동 sob
😱 겁에 질려 소리치는 얼굴|충격 비명 scream
😖 괴로운 얼굴|괴로움 confounded
😣 참는 얼굴|힘듦 persevere
😞 실망한 얼굴|실망 disappointed
😓 진땀 흘리는 얼굴|힘듦 downcast sweat
😩 지친 얼굴|피곤 지침 weary
😫 녹초가 된 얼굴|피곤 지침 tired
🥱 하품하는 얼굴|졸림 지루함 yawn
😤 콧김을 내뿜는 얼굴|의지 화이팅 분노 triumph huff
😡 화난 얼굴|분노 화남 angry
😠 성난 얼굴|화남 angry
😈 웃는 악마|장난 악마 devil
💀 해골|웃겨죽음 ㅋㅋ skull dead
💩 똥|장난 poop
🤡 광대 얼굴|광대 clown
👻 유령|장난 ghost
👽 외계인|외계인 alien
🤖 로봇|로봇 봇 robot
😺 웃는 고양이 얼굴|고양이 cat smile`,
  hands: `👍 엄지척|좋아요 최고 굿 오케이 따봉 동의 like thumbs up good
👎 엄지 아래|싫어요 별로 반대 thumbs down
👌 오케이 손|좋아 확인 ok
🤌 손끝을 모은 손|pinched fingers
✌️ 브이|평화 승리 victory peace
🤞 손가락 꼬기|행운 기원 fingers crossed
🫰 손가락 하트|사랑 하트 love
🤟 사랑해 손|사랑 love you
🤘 락 손|락 신남 rock
🤙 전화해 손|연락 call me
👈 왼쪽을 가리키는 손|왼쪽 left
👉 오른쪽을 가리키는 손|오른쪽 right
👆 위를 가리키는 손|위 up
👇 아래를 가리키는 손|아래 down
☝️ 검지를 든 손|하나 주목 index pointing up
🫵 나를 가리키는 손|너 you
👋 손 흔들기|안녕 인사 반가워 hello wave hi
🤚 손등을 든 손|손 raised back
🖐️ 다섯 손가락을 편 손|다섯 hand splayed
✋ 손바닥을 든 손|멈춤 저요 raised hand
🖖 벌컨 인사|vulcan
👏 박수|박수 짝짝 축하 칭찬 clap
🙌 만세|만세 축하 환영 hooray raising hands
🫶 하트 손|사랑 하트 고마워 heart hands
👐 펼친 두 손|open hands
🤲 모은 두 손바닥|기도 부탁 palms up
🤝 악수|협력 합의 동의 handshake deal
🙏 두 손 모으기|감사 부탁 기도 고마워 please thanks pray
✍️ 글 쓰는 손|메모 작성 writing
💪 이두박근|힘내 화이팅 파이팅 strong muscle
🙇 꾸벅 인사하는 사람|죄송 감사 인사 bow
🙋 손 든 사람|저요 질문 raising hand
🙆 오케이 동작을 하는 사람|좋아요 오케이 gesturing ok
🙅 엑스 동작을 하는 사람|안돼 금지 gesturing no
🤷 어깨를 으쓱하는 사람|글쎄 몰라 shrug
🤦 손으로 얼굴을 가린 사람|어이없음 facepalm
💁 안내하는 사람|안내 정보 tipping hand
🏃 달리는 사람|급함 달려 running
🧑‍💻 컴퓨터 하는 사람|개발 코딩 업무 technologist developer
👀 두 눈|확인 중 보는 중 봤어요 eyes look
🧠 뇌|생각 아이디어 brain
👂 귀|듣기 경청 ear`,
  symbols: `❤️ 빨간 하트|사랑 좋아 하트 love red heart
🧡 주황 하트|하트 orange heart
💛 노란 하트|하트 yellow heart
💚 초록 하트|하트 green heart
💙 파란 하트|하트 blue heart
💜 보라 하트|하트 purple heart
🖤 검은 하트|하트 black heart
🤍 하얀 하트|하트 white heart
🤎 갈색 하트|하트 brown heart
💖 반짝이는 하트|사랑 sparkling heart
💕 두 개의 하트|사랑 two hearts
💯 100점|최고 완벽 백점 hundred
✅ 체크 표시 상자|확인 완료 done check
☑️ 체크한 상자|확인 완료 check box
✔️ 체크 표시|확인 완료 check mark
❌ 엑스 표시|안돼 아니오 취소 실패 cross no
❎ 엑스 표시 상자|취소 cross mark button
⭕ 동그라미|맞음 정답 circle
❗ 느낌표|중요 주의 exclamation
❓ 물음표|질문 궁금 question
‼️ 이중 느낌표|중요 강조 double exclamation
⁉️ 느낌표와 물음표|놀람 질문 interrobang
⚠️ 경고|주의 위험 warning
🚫 금지|금지 안돼 prohibited
⛔ 진입 금지|금지 멈춤 no entry
🆗 오케이 버튼|좋아 ok button
🆕 새로움 버튼|신규 새로 new
🆙 업 버튼|업 상승 up button
🔴 빨간 원|빨강 red circle
🟡 노란 원|노랑 대기 yellow circle
🟢 초록 원|초록 진행 green circle
🔵 파란 원|파랑 blue circle
⭐ 별|즐겨찾기 최고 star
🌟 빛나는 별|최고 glowing star
✨ 반짝임|반짝 새것 깔끔 sparkles
💫 어지러운 별|dizzy star
⚡ 번개|빠름 전기 lightning
🔥 불|대박 핫 인기 열정 fire hot
💥 쾅|폭발 충돌 boom collision
💬 말풍선|대화 말 speech balloon
💭 생각 풍선|생각 thought balloon
💤 졸음|zzz 잠 sleep
➕ 더하기|추가 플러스 plus
➖ 빼기|마이너스 minus
🔔 종|알림 bell
🔕 꺼진 종|알림끔 무음 mute
♻️ 재활용|재사용 recycle
🔁 반복|다시 repeat`,
  objects: `🎉 파티 폭죽|축하 파티 생일 대박 celebration party tada
🎊 색종이 공|축하 confetti
🎂 생일 케이크|생일 축하 birthday cake
🎁 선물|선물 감사 gift present
🎈 풍선|축하 balloon
🏆 트로피|우승 최고 1등 trophy
🥇 금메달|1등 우승 gold medal
🥈 은메달|2등 silver medal
🥉 동메달|3등 bronze medal
🏅 메달|메달 sports medal
🎯 과녁|목표 정확 명중 target bullseye
🚀 로켓|출시 배포 시작 launch rocket
💡 전구|아이디어 생각 idea bulb
📌 압정|고정 공지 중요 pushpin
📍 둥근 압정|위치 장소 round pushpin
📎 클립|첨부 paperclip
✏️ 연필|수정 작성 pencil
📝 메모|기록 작성 memo note
📋 클립보드|목록 체크리스트 clipboard
📅 달력|일정 날짜 calendar
🗓️ 나선 달력|일정 계획 spiral calendar
⏰ 알람 시계|알람 시간 마감 alarm clock
⏳ 모래시계|대기 기다림 진행 중 hourglass wait
⌛ 다 떨어진 모래시계|시간 끝 hourglass done
⏱️ 스톱워치|시간 측정 stopwatch
📈 상승 그래프|성장 증가 상승 chart up
📉 하락 그래프|감소 하락 chart down
📊 막대 그래프|통계 데이터 bar chart
💼 서류 가방|업무 회사 briefcase work
📁 파일 폴더|폴더 자료 folder
📂 열린 파일 폴더|폴더 자료 open folder
📄 문서|자료 document page
📑 책갈피 탭|문서 bookmark tabs
📚 책|공부 자료 books
💻 노트북|컴퓨터 개발 업무 laptop
🖥️ 데스크톱 컴퓨터|컴퓨터 desktop computer
⌨️ 키보드|입력 keyboard
🖱️ 마우스|컴퓨터 mouse
📱 휴대폰|전화 모바일 mobile phone
☎️ 전화기|전화 telephone
📞 수화기|전화 통화 phone call
📧 이메일|메일 email
📨 받은 편지|메일 수신 incoming envelope
📬 우편함|메일 mailbox
🔍 돋보기|검색 찾기 확인 search
🔒 자물쇠|보안 잠금 lock
🔑 열쇠|비밀번호 key
🛠️ 망치와 렌치|수리 작업 도구 tools
🔧 렌치|수리 설정 wrench
⚙️ 톱니바퀴|설정 gear settings
🧩 퍼즐 조각|연결 puzzle
💰 돈 자루|돈 예산 money bag
💸 날개 달린 돈|지출 돈 money flying
🧾 영수증|비용 receipt
📢 확성기|공지 알림 안내 loudspeaker
📣 메가폰|공지 응원 megaphone
🔗 링크|연결 link
🏁 체크무늬 깃발|완료 끝 결승 finish flag
🚩 삼각 깃발|문제 표시 triangular flag
🚧 공사 중|작업 중 공사 construction wip
🗑️ 휴지통|삭제 버림 trash wastebasket
🧹 빗자루|정리 청소 broom
✂️ 가위|자르기 편집 scissors
📦 상자|배송 패키지 package box`,
  nature: `☕ 커피|카페 휴식 coffee
🍵 녹차|차 tea
🧋 버블티|bubble tea
🍺 맥주|회식 beer
🍻 건배하는 맥주잔|건배 회식 cheers
🥂 건배하는 샴페인 잔|건배 축하 champagne
🍷 와인|wine
🍕 피자|점심 pizza
🍔 햄버거|점심 burger
🍜 라면|국수 점심 ramen noodle
🍚 밥|식사 점심 rice
🍱 도시락|점심 bento
🍣 초밥|sushi
🍗 닭다리|치킨 chicken
🍰 케이크 조각|디저트 cake
🍩 도넛|간식 donut
🍪 쿠키|간식 cookie
🍫 초콜릿|간식 chocolate
🍎 사과|apple
🍓 딸기|strawberry
🍉 수박|여름 watermelon
🍞 식빵|빵 bread
🌶️ 고추|매움 hot pepper
🐶 강아지 얼굴|강아지 개 dog
🐱 고양이 얼굴|고양이 냥이 cat
🐻 곰 얼굴|곰 bear
🐼 판다 얼굴|판다 panda
🐰 토끼 얼굴|토끼 rabbit
🐯 호랑이 얼굴|호랑이 tiger
🦊 여우 얼굴|여우 fox
🐧 펭귄|penguin
🐣 부화하는 병아리|병아리 신입 hatching chick
🐢 거북이|느림 turtle slow
🦄 유니콘|unicorn
🐛 애벌레|버그 bug
🐞 무당벌레|버그 오류 lady beetle bug
🌸 벚꽃|봄 꽃 cherry blossom
🌷 튤립|꽃 tulip
🌹 장미|꽃 rose
🌻 해바라기|꽃 sunflower
💐 꽃다발|축하 감사 꽃 bouquet
🍀 네잎클로버|행운 four leaf clover luck
🌱 새싹|시작 성장 seedling
🌲 나무|tree
☀️ 해|맑음 햇빛 sun
🌤️ 구름에 가린 해|맑음 날씨 sun behind cloud
☁️ 구름|흐림 cloud
🌧️ 비구름|비 rain
☔ 비 맞는 우산|비 우산 umbrella rain
❄️ 눈송이|눈 추위 snowflake
⛄ 눈사람|눈 겨울 snowman
🌈 무지개|rainbow
🌙 초승달|밤 달 crescent moon night
🌊 파도|바다 wave ocean
🌍 지구|세계 earth world globe`,
  activities: `⚽ 축구공|축구 soccer
🏀 농구공|농구 basketball
⚾ 야구공|야구 baseball
🎾 테니스공|테니스 tennis
🏸 배드민턴|badminton
🎮 게임 컨트롤러|게임 video game
🎲 주사위|게임 랜덤 dice
🎵 음표|음악 노래 music note
🎧 헤드폰|음악 집중 headphones
🎤 마이크|노래 발표 microphone
🎬 클래퍼보드|영화 시작 clapper board
📸 플래시 카메라|사진 camera flash
🎨 팔레트|디자인 그림 art palette
🏋️ 역기 드는 사람|운동 헬스 weight lifting
🚴 자전거 타는 사람|자전거 운동 cycling
🧘 명상하는 사람|명상 요가 휴식 yoga
✈️ 비행기|출장 여행 airplane travel
🚗 자동차|차 출근 car
🚌 버스|출근 bus
🚇 지하철|출근 metro subway
🚲 자전거|bicycle
🏠 집|재택 home house
🏢 사무실 건물|회사 사무실 office building
🏖️ 해변|휴가 바다 beach vacation
⛰️ 산|등산 mountain
🗺️ 세계 지도|지도 여행 world map
🧳 여행 가방|출장 여행 luggage
🛫 이륙하는 비행기|출발 출장 departure
🎄 크리스마스트리|크리스마스 성탄절 christmas tree
🎃 호박 등|핼러윈 jack-o-lantern halloween
🧧 붉은 봉투|세뱃돈 설날 red envelope`,
};

export interface EmojiEntry {
  emoji: string;
  /** Korean name: the button's accessible name. */
  name: string;
  /** Name and search words, lower-cased, with their initial consonants ("ㅊㅎ" finds 축하). */
  search: string;
}

export type EmojiGroupKey = keyof typeof GROUPS;

/** Category tabs of the picker: label for screen readers, an emoji as the tab's face. */
export const EMOJI_GROUPS: ReadonlyArray<{ key: EmojiGroupKey; label: string; face: string }> = [
  { key: 'faces', label: '표정', face: '😀' },
  { key: 'hands', label: '손짓·사람', face: '👍' },
  { key: 'symbols', label: '하트·기호', face: '❤️' },
  { key: 'objects', label: '축하·업무', face: '🎉' },
  { key: 'nature', label: '음식·자연', face: '☕' },
  { key: 'activities', label: '활동·여행', face: '⚽' },
];

/** The quick set: offered first, in this order, so they stay where the hand expects them. */
export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏', '✅', '🎉'] as const;

const INITIALS = 'ㄱㄲㄴㄷㄸㄹㅁㅂㅃㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎ';

/** "축하 파티" → "ㅊㅎ ㅍㅌ": a syllable's initial consonant, anything else as it is. */
function initialsOf(text: string): string {
  return [...text].map((char) => {
    const code = char.charCodeAt(0) - 0xac00;
    return code >= 0 && code <= 11171 ? INITIALS[Math.floor(code / 588)]! : char;
  }).join('');
}

function normalized(text: string): string {
  return text.normalize('NFC').trim().toLowerCase();
}

function parse(lines: string): EmojiEntry[] {
  return lines.split('\n').map((line) => {
    const space = line.indexOf(' ');
    const [name, words = ''] = line.slice(space + 1).split('|') as [string, string?];
    const text = normalized(`${name} ${words}`);
    return { emoji: line.slice(0, space), name, search: `${text} ${initialsOf(text)}` };
  });
}

const BY_GROUP = Object.fromEntries(Object.entries(GROUPS).map(([key, lines]) => [key, parse(lines)])) as Record<EmojiGroupKey, EmojiEntry[]>;
const ALL = Object.values(BY_GROUP).flat();
const BY_EMOJI = new Map(ALL.map((entry) => [entry.emoji, entry]));

export function emojiInGroup(key: EmojiGroupKey): readonly EmojiEntry[] {
  return BY_GROUP[key];
}

export function emojiEntry(emoji: string): EmojiEntry {
  return BY_EMOJI.get(emoji) ?? { emoji, name: emoji, search: emoji };
}

const QUICK = new Set<string>(QUICK_REACTIONS);

/**
 * Picker search: every word of the query must appear in the name or the search words
 * (Korean, English, or only initial consonants). Names that start with the query come
 * first, then words that do; among equals the quick set leads.
 */
export function searchEmoji(query: string, limit = 48): EmojiEntry[] {
  const words = normalized(query).split(/\s+/).filter(Boolean);
  if (!words.length) return [];
  const first = words[0]!;
  const rank = (entry: EmojiEntry) => {
    const match = entry.name.startsWith(first) ? 0 : entry.search.split(' ').some((word) => word.startsWith(first)) ? 2 : 4;
    return match + (QUICK.has(entry.emoji) ? 0 : 1);
  };
  return ALL.filter((entry) => words.every((word) => entry.search.includes(word)))
    .map((entry, index) => ({ entry, index, rank: rank(entry) }))
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .slice(0, limit)
    .map((hit) => hit.entry);
}
